<template lang="pug">
  el-main(style="text-align: center; margin-top: 10%;")
    // hvu-canvas logo
    el-row
      el-col(:span="24" style="margin-bottom:2%;")  
        img(src="../assets/settingup.png")

    el-row
      el-col(:span="24")
        // notifications
        h3(:class="{ 'text-normal' : loading, 'text-error' : !loading }"
          v-model="info") {{ info }}

        // loading spinner
        div(
          v-loading="loading"
          :style="{ visibility: spinnerVisible }"
          style="margin-top: 50px;")  
</template>

<script>
  import { ERROR_VUE } from '@/defines/errors'
  import utilMixin from '@/components/mixins/utilMixin'

  export default {
    name: 'Register',

    mixins: [utilMixin],

    data() {
      return {
        loading: true,
        info: 'Please wait while you are being signed in.',
        spinnerVisible: 'visible',
      }
    },

    mounted() {
      this.register()
    },

    methods: {
      register() {
        this.axios.post('/api/register')
          .then((result) => {
            this.$store.commit('setInfo',result.data.launchInfo)
            this.$store.state.welcomed = result.data.firstTimeLogin

            if (result.data.user !== undefined) {
              this.$store.commit('setAdminInfo', result.data.user)
            }

            if (this.mIsBrowserIE() && result.data.redirectRoute !== 'home') {
              this.mNotification({title: "Warning",
              plain: 'We have detected that you are using Internet Explorer. We highly recommend to use other browsers such as Chrome, Firefox, Safari  or Edge for a smoother user experience.'})
            }
           
            if (this.$store.getters.welcome) {
              this.$notify({
                title: 'Welcome back,',
                message: result.data.launchInfo.userFirstName,
                type: 'success',
              }) 
            }
            this.$router.push({path: result.data.redirectRoute})
          })
          .catch((error) => { 
            let errorCode = error.response != undefined ? error.response.status: error.code || ERROR_VUE
            this.disablePage('Cannot establish connection to remote host while attempting to sign in. Error: ' + errorCode ) 
          })
      },

      disablePage(errorMsg) {
        this.info = errorMsg
        this.loading = false
        this.spinnerVisible = 'hidden'
      },
    },
  }
</script>

<style module>
  .text-normal {
    color: #909399;
  }

  .text-error {
    color: #F56C6C;
  }
</style>